import { useState } from 'react'
import { useInterval } from 'usehooks-ts'

type ReturnProps = {
    isRunning: boolean
    setRunning: (toggle: boolean) => void
    delay: number | undefined
    setDelay: (interval: number | undefined) => void
}

export default function useDelayedInterval(interval: number | undefined, callback: () => void): ReturnProps {
    const [isRunning, setRunning] = useState<boolean>(false)
    const [delay, setDelay] = useState<number>(interval)

    useInterval(
        callback,
        // Delay in milliseconds or null to stop it
        isRunning ? delay : null,
    )

    return { isRunning, setRunning, delay, setDelay }
}
